export const PENDING = 1
export const PROCESSING = 2
export const COMPLETED = 3
export const PARCIAL = 4
export const ROLLBACKED = 5
export const FAILED = 6